angular.module('ihestiaCommonDirectives.bsDatepickerPropperPlTitle', [
    'lsnBase.bsDatepickerPropperPlTitle'
  ]);